import { sanitizeNumericInput } from "./numeric-input-utils";

import { Input } from "@/components/ui/input";

interface TextValueInputProps {
  inputRef: React.RefObject<HTMLInputElement | null>;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  onBlur: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  placeholder: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  sanitizeNumeric?: boolean;
  allowCurrencyPrefix?: boolean;
  allowUnitSuffix?: boolean;
}

const TextValueInput = ({
  inputRef,
  value,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  placeholder,
  inputMode,
  sanitizeNumeric = false,
  allowCurrencyPrefix = false,
  allowUnitSuffix = false,
}: TextValueInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = sanitizeNumeric
      ? sanitizeNumericInput(e.target.value, { allowCurrencyPrefix, allowUnitSuffix })
      : e.target.value;
    onChange({ ...e, target: { ...e.target, value: next } });
  };
  const handleBlur = () => {
    if (sanitizeNumeric && value.endsWith(".")) {
      onChange({ target: { value: `${value}0` } } as React.ChangeEvent<HTMLInputElement>);
    }
    onBlur();
  };
  return (
    <Input
      ref={inputRef as React.Ref<HTMLInputElement>}
      type="text"
      inputMode={inputMode}
      value={value}
      onChange={handleChange}
      onFocus={onFocus}
      onBlur={handleBlur}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      className="h-7 w-full min-w-0 flex-1 truncate border-0 bg-transparent px-0 py-[5px] text-[15px] text-slate-700 placeholder:text-slate-400 focus-visible:ring-0 focus-visible:ring-offset-0"
    />
  );
};

export default TextValueInput;
